import { ValidationError } from 'ProdantixSdk/core/errors';

const PROJECT_KEY_RE = /^pdx_pub_(?:(?:live|test)_)?[a-z0-9]{32}$/;
const GUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const EVENT_NAME_RE = /^(?:\$|[a-z])[a-z0-9_.]*$/;
const ISO_DATETIME_OFFSET_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;

export function codePointLength(value: string): number {
  let count = 0;
  for (const _ of value) {
    count += 1;
  }
  return count;
}

export function isProjectKey(value: string): boolean {
  return PROJECT_KEY_RE.test(value);
}

export function isGuid(value: string): boolean {
  return GUID_RE.test(value);
}

export function isEventName(value: string): boolean {
  return EVENT_NAME_RE.test(value);
}

export function isIsoDatetimeOffset(value: string): boolean {
  return ISO_DATETIME_OFFSET_RE.test(value);
}

export function assertDistinctId(value: string): void {
  const length = codePointLength(value);
  if (length < 1 || length > 200) {
    throw new ValidationError('distinct_id', 'distinct_id must be between 1 and 200 characters');
  }
}

export function assertEventName(value: string): void {
  const length = codePointLength(value);
  if (length < 1 || length > 200) {
    throw new ValidationError('event_name', 'event_name must be between 1 and 200 characters');
  }
  if (!isEventName(value)) {
    throw new ValidationError('event_name', 'event_name must match /^(\\$|[a-z])[a-z0-9_.]*$/');
  }
}
